// metricsConfig.js
export const getMetricsConfig = (data, getStatusColor, getMarginPercentStatus, getInventoryHealthStatus) => [
    {
        title: 'Planned Inventory Spend',
        goalDetails: [
            'Goal',
            'Margin %: 23.4%',
        ],
        rows: [
            {
                label: 'Spend',
                boxes: [
                    {
                        title: 'Month to Date',
                        value: data.inventoryPlannedSpendMTD,
                        status: 'gray',
                        format: 'currency',
                        mode: 'MTD'
                    },
                    {
                        title: 'Qtr to Date',
                        value: data.inventoryPlannedSpendQTD,
                        status: 'gray',
                        format: 'currency',
                        mode: 'QTD'
                    },
                    {
                        title: 'Year to Date',
                        value: data.inventoryPlannedSpendYTD,
                        status: 'gray',
                        format: 'currency',
                        mode: 'YTD'
                    }
                ]
            },
            {
                label: 'Projected Margin %',
                boxes: [
                    {
                        title: 'Month to Date',
                        value: data.inventoryPlannedSpendProjectedMarginPercentMTD,
                        status: getMarginPercentStatus(data.inventoryPlannedSpendProjectedMarginPercentMTD),
                        format: 'percent',
                        mode: 'MTD'
                    },
                    {
                        title: 'Qtr to Date',
                        value: data.inventoryPlannedSpendProjectedMarginPercentQTD,
                        status: getMarginPercentStatus(data.inventoryPlannedSpendProjectedMarginPercentQTD),
                        format: 'percent',
                        mode: 'QTD'
                    },
                    {
                        title: 'Year to Date',
                        value: data.inventoryPlannedSpendProjectedMarginPercentYTD,
                        status: getMarginPercentStatus(data.inventoryPlannedSpendProjectedMarginPercentYTD),
                        format: 'percent',
                        mode: 'YTD'
                    }
                ]
            },
            {
                label: 'Projected Margin $',
                boxes: [
                    {
                        title: 'Month to Date',
                        value: data.inventoryPlannedSpendProjectedMarginDollarsMTD,
                        status: 'gray',
                        format: 'currency',
                        mode: 'MTD'
                    },
                    {
                        title: 'Qtr to Date',
                        value: data.inventoryPlannedSpendProjectedMarginDollarsQTD,
                        status: 'gray',
                        format: 'currency',
                        mode: 'QTD'
                    },
                    {
                        title: 'Year to Date',
                        value: data.inventoryPlannedSpendProjectedMarginDollarsYTD,
                        status: 'gray',
                        format: 'currency',
                        mode: 'YTD'
                    }
                ]
            }
        ],
        landed: {
            title: 'Landed Inventory Spend',
            goalDetails: [
                'Annual Goal',
                'Spend Goal: $10.95M',
                'Margin %: 23.4%',
                'Margin $: $300K'
            ],
            rows: [
                {
                    label: 'Spend',
                    boxes: [
                        {
                            title: 'Month to Date',
                            value: data.inventoryLandedSpendMTD,
                            status: getStatusColor(data.inventoryLandedSpendMTD, 912500, true, 0.75),
                            format: 'currency',
                            mode: 'MTD'
                        },
                        {
                            title: 'Qtr to Date',
                            value: data.inventoryLandedSpendQTD,
                            status: getStatusColor(data.inventoryLandedSpendQTD, 2737500, true, 0.75),
                            format: 'currency',
                            mode: 'QTD'
                        },
                        {
                            title: 'Year to Date',
                            value: data.inventoryLandedSpendYTD,
                            status: getStatusColor(data.inventoryLandedSpendYTD, 10950000, true, 0.75),
                            format: 'currency',
                            mode: 'YTD'
                        }
                    ]
                },
                {
                    label: 'Projected Margin %',
                    boxes: [
                        {
                            title: 'Month to Date',
                            value: data.inventoryLandedSpendProjectedMarginPercentMTD,
                            status: getMarginPercentStatus(data.inventoryLandedSpendProjectedMarginPercentMTD),
                            format: 'percent',
                            mode: 'MTD'
                        },
                        {
                            title: 'Qtr to Date',
                            value: data.inventoryLandedSpendProjectedMarginPercentQTD,
                            status: getMarginPercentStatus(data.inventoryLandedSpendProjectedMarginPercentQTD),
                            format: 'percent',
                            mode: 'QTD'
                        },
                        {
                            title: 'Year to Date',
                            value: data.inventoryLandedSpendProjectedMarginPercentYTD,
                            status: getMarginPercentStatus(data.inventoryLandedSpendProjectedMarginPercentYTD),
                            format: 'percent',
                            mode: 'YTD'
                        }
                    ]
                },
                {
                    label: 'Projected Margin $',
                    boxes: [
                        {
                            title: 'Month to Date',
                            value: data.inventoryLandedSpendProjectedMarginDollarsMTD,
                            status: getStatusColor(data.inventoryLandedSpendProjectedMarginDollarsMTD, 300000, true, 0.75),
                            format: 'currency',
                            mode: 'MTD'
                        },
                        {
                            title: 'Qtr to Date',
                            value: data.inventoryLandedSpendProjectedMarginDollarsQTD,
                            status: getStatusColor(data.inventoryLandedSpendProjectedMarginDollarsQTD, 900000, true, 0.75),
                            format: 'currency',
                            mode: 'QTD'
                        },
                        {
                            title: 'Year to Date',
                            value: data.inventoryLandedSpendProjectedMarginDollarsYTD,
                            status: getStatusColor(data.inventoryLandedSpendProjectedMarginDollarsYTD, 3600000, true, 0.75),
                            format: 'currency',
                            mode: 'YTD'
                        }
                    ]
                }
            ]
        }
    },
    {
        title: 'Revenue/Margin',
        goalDetails: [
            'Monthly Goal',
            'Rev: $1.1M',
            'Margin %: 23.4%',
            'Margin $: $300K'
        ],
        rows: [
            {
                label: 'Revenue',
                boxes: [
                    {
                        title: 'Month to Date',
                        value: data.revenueMTD,
                        status: getStatusColor(data.revenueMTD, 1100000, true, 0.75),
                        format: 'currency',
                        mode: 'MTD'
                    },
                    {
                        title: 'Qtr to Date',
                        value: data.revenueQTD,
                        status: getStatusColor(data.revenueQTD, 3300000, true, 0.75),
                        format: 'currency',
                        mode: 'QTD'
                    },
                    {
                        title: 'Year to Date',
                        value: data.revenueYTD,
                        status: getStatusColor(data.revenueYTD, 13200000, true, 0.75),
                        format: 'currency',
                        mode: 'YTD'
                    }
                ]
            },
            {
                label: 'Gross Margin %',
                boxes: [
                    {
                        title: 'Month to Date',
                        value: data.revenueGrossMarginPercentMTD,
                        status: getMarginPercentStatus(data.revenueGrossMarginPercentMTD),
                        format: 'percent',
                        mode: 'MTD'
                    },
                    {
                        title: 'Qtr to Date',
                        value: data.revenueGrossMarginPercentQTD,
                        status: getMarginPercentStatus(data.revenueGrossMarginPercentQTD),
                        format: 'percent',
                        mode: 'QTD'
                    },
                    {
                        title: 'Year to Date',
                        value: data.revenueGrossMarginPercentYTD,
                        status: getMarginPercentStatus(data.revenueGrossMarginPercentYTD),
                        format: 'percent',
                        mode: 'YTD'
                    }
                ]
            },
            {
                label: 'Gross Margin $',
                boxes: [
                    {
                        title: 'Month to Date',
                        value: data.revenueGrossMarginDollarsMTD,
                        status: getStatusColor(data.revenueGrossMarginDollarsMTD, 300000, true, 0.75),
                        format: 'currency',
                        mode: 'MTD'
                    },
                    {
                        title: 'Qtr to Date',
                        value: data.revenueGrossMarginDollarsQTD,
                        status: getStatusColor(data.revenueGrossMarginDollarsQTD, 900000, true, 0.75),
                        format: 'currency',
                        mode: 'QTD'
                    },
                    {
                        title: 'Year to Date',
                        value: data.revenueGrossMarginDollarsYTD,
                        status: getStatusColor(data.revenueGrossMarginDollarsYTD, 3600000, true, 0.75),
                        format: 'currency',
                        mode: 'YTD'
                    }
                ]
            }
        ]
    },
    {
        title: 'Inventory Health',
        goalDetails: [
            '0-90 56%',
            '91-180 26%',
            '181-365 16%',
            '366+ 2%'
        ],
        rows: [
            {
                label: '0-90',
                boxes: [
                    {
                        title: 'Current',
                        value: data.inventoryHealthPercent90,
                        status: getInventoryHealthStatus(data.inventoryHealthPercent90, '0-90'),
                        format: 'percent'
                    }
                ]
            },
            {
                label: '91-180',
                boxes: [
                    {
                        title: 'Current',
                        value: data.inventoryHealthPercent180,
                        status: getInventoryHealthStatus(data.inventoryHealthPercent180, '91-180'),
                        format: 'percent'
                    }
                ]
            },
            {
                label: '181-365',
                boxes: [
                    {
                        title: 'Current',
                        value: data.inventoryHealthPercent365,
                        status: getInventoryHealthStatus(data.inventoryHealthPercent365, '181-365'),
                        format: 'percent'
                    }
                ]
            },
            {
                label: '366+',
                boxes: [
                    {
                        title: 'Current',
                        value: data.inventoryHealthPercent365Plus,
                        status: getInventoryHealthStatus(data.inventoryHealthPercent365Plus, '366+'),
                        format: 'percent'
                    }
                ]
            }
        ]
    },
    {
        title: 'New Vendor Base Growth',
        goalDetails: [
            'Annual Goal',
            'Increase Vendor base by 84'
        ],
        rows: [
            {
                label: '# of PO Actual',
                boxes: [
                    {
                        title: 'Month to Date',
                        value: data.newVendorPOActualMTD,
                        status: getStatusColor(data.newVendorPOActualMTD, 18, true, 14 / 18),
                        format: 'number',
                        mode: 'MTD'
                    },
                    {
                        title: 'Qtr to Date',
                        value: data.newVendorPOActualQTD,
                        status: getStatusColor(data.newVendorPOActualQTD, 54, true, 40 / 54),
                        format: 'number',
                        mode: 'QTD'
                    },
                    {
                        title: 'Year to Date',
                        value: data.newVendorPOActualYTD,
                        status: getStatusColor(data.newVendorPOActualYTD, 225, true, 168 / 225),
                        format: 'number',
                        mode: 'YTD'
                    }
                ]
            },
            {
                label: '# of PO Pace',
                boxes: [
                    {
                        title: 'Month to Date',
                        value: data.newVendorPOPaceMTD,
                        status: 'gray',
                        format: 'percent'
                    },
                    {
                        title: 'Qtr to Date',
                        value: data.newVendorPOPaceQTD,
                        status: 'gray',
                        format: 'percent'
                    },
                    {
                        title: 'Year to Date',
                        value: data.newVendorPOPaceYTD,
                        status: 'gray',
                        format: 'percent'
                    }
                ]
            },
            {
                label: '# of RFQs',
                boxes: [
                    {
                        title: 'Month to Date',
                        value: data.newVendorRFQActualMTD,
                        status: 'gray',
                        format: 'number',
                        mode: 'MTD',
                        tooltip: 'xyz',
                    },
                    {
                        title: 'Qtr to Date',
                        value: data.newVendorRFQActualQTD,
                        status: 'gray',
                        format: 'number',
                        mode: 'QTD'
                    },
                    {
                        title: 'Year to Date',
                        value: data.newVendorRFQActualYTD,
                        status: 'gray',
                        format: 'number',
                        mode: 'YTD'
                    }
                ]
            }
        ],
        directSource: "TBD"
    }
];